export default {
  auditTrail: {
    items: {},
  },
};
